import { CULTURE_INFO, CULTURE_LANG } from 'globalconfig';
var global = {
    CULTURE_INFO: CULTURE_INFO,
    CULTURE_LANG: CULTURE_LANG
};
export default global;
